import IntegratedHelpCenter from "./pages/IntegratedHelpCenter"; // Lot 4I-I2
import AdminContentGovernance from "./pages/AdminContentGovernance"; // Lot 4H-H2
import {
  ForfeoRouteBoundary,
  ForfeoRouteExperience,
} from "./components/ui/ForfeoRouteExperience"; // Lot 4G-G2
// src/App.tsx
import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

// --- PAGES ---
import Home from './pages/Home';
import About from './pages/About';
import RegionDetail from './pages/RegionDetail';
import Business from './pages/Business';
import MerchantOnboarding from './pages/MerchantOnboarding';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import TermsLoyalty from './pages/TermsLoyalty';
import ClubForfeo from './pages/ClubForfeo';
import Login from './pages/Login';
import BusinessDashboard from './pages/BusinessDashboard';
import SignContract from './pages/SignContract';
import LocalNetwork from './pages/LocalNetwork';
import Admin from './pages/Admin';
import AdminOperations from "./pages/AdminOperations";
import LastCall from './pages/LastCall';
import ForfeoFinds from './pages/ForfeoFinds';
import Boutique from './pages/Boutique';
import BoutiqueDetail from './pages/BoutiqueDetail';
import Checkout from './pages/Checkout';
import VisitQuebec from './pages/VisitQuebec';
import ExplorePlus from './pages/ExplorePlus';
import BusinessProfile from './pages/BusinessProfile';
import BookingPage from './pages/BookingPage';
import BookingSuccess from './pages/BookingSuccess';
import ReservePartnerWidgetPage from './pages/ReservePartnerWidgetPage'; // Lot 4R-H
import SeoCityLanding from './pages/SeoCityLanding';
import AgentConsole from './pages/AgentConsole';
import AffiliateDashboard from './pages/AffiliateDashboard';
import PRPDashboard from './pages/PRPDashboard';
import PrpGrowthCockpit from './components/prp/PrpGrowthCockpit';
import NewsletterUnsubscribe from './pages/NewsletterUnsubscribe';
import ServiceClient from './pages/ServiceClient';
import ForfaitPresale from './pages/ForfaitPresale';
import AiTripBuilder from './pages/AiTripBuilder';
import ForfeoDrops from './pages/ForfeoDrops';
import Evasion from './pages/Evasion';
import TravelComparator from './pages/TravelComparator'; // ✅ NOUVELLE PAGE : FORFEO ÉVASION
import EvasionDashboard from './pages/EvasionDashboard'; // ✅ NOUVELLE PAGE : DASHBOARD ÉVASION
import SmartAlerts from './pages/SmartAlerts';
import SmartAlertsDashboard from './pages/SmartAlertsDashboard';
import MyFavorites from './pages/MyFavorites';
import TravelerDashboard from './pages/TravelerDashboard';
import AccountLifecycle from './pages/AccountLifecycle';
import MyReservations from './pages/MyReservations';
import ReservationDetail from './pages/ReservationDetail';
import MyPurchases from './pages/MyPurchases';
import VoucherDetail from './pages/VoucherDetail';
import DiscoverQuebec from './pages/DiscoverQuebec';
import GiftMoment from './pages/GiftMoment';
import OccasionCalendar from './pages/OccasionCalendar';
import SurpriseReveal from './pages/SurpriseReveal';
import ReviewAfterExperience from './pages/ReviewAfterExperience';
import PublicCombos from './pages/PublicCombos';
import PublicComboDetail from './pages/PublicComboDetail';
import MerchantCombos from './pages/MerchantCombos';
import QualityServices from './pages/QualityServices';
import PartnerCombosBrochure from './pages/PartnerCombosBrochure';
import ForfeoUniverseBridge from './pages/ForfeoUniverseBridge';
import PublicReviews from './pages/PublicReviews';
import AdminQualityServices from './pages/AdminQualityServices';
import AdminSecurityCenter from './pages/AdminSecurityCenter';
import AdminPartnerMaterials from './pages/AdminPartnerMaterials';
import AdminCombos from './pages/AdminCombos';
import AdminCommissionSettings from './pages/AdminCommissionSettings';
import AdminEmailSequences from './pages/AdminEmailSequences';
import AdminExperienceReviews from './pages/AdminExperienceReviews';
import AdminLastCallReservations from './pages/AdminLastCallReservations';
import AdminReserveIntegrations from './pages/AdminReserveIntegrations'; // Lot 4R-J
import AdminLeads from './pages/AdminLeads';
import AdminMarketingAnalytics from './pages/AdminMarketingAnalytics';
import AdminExplorerPlusAnalytics from './pages/AdminExplorerPlusAnalytics';
import AdminOrdersVouchers from './pages/AdminOrdersVouchers';

// ✅ PAGES CONFIANCE / SEO / CONVERSION
import CommentCaMarche from './pages/CommentCaMarche';
import Confiance from './pages/Confiance';
import Aide from './pages/Aide';
import Partenaires from './pages/Partenaires';
import CarteCadeauUniverselle from './pages/CarteCadeauUniverselle';

// ✅ NOUVELLE PAGE : DÉMO DYNAMIQUE IA (SDR)
import DynamicDemo from './pages/DynamicDemo';

// ✅ VERTICALE : HABITAT
import HabitatLanding from './features/habitat/pages/HabitatLanding';
import LandlordDashboard from './features/habitat/pages/LandlordDashboard';
import TenantDashboard from './features/habitat/pages/TenantDashboard';
import HabitatListing from './features/habitat/pages/HabitatListing';
import HabitatLandlordProfile from './features/habitat/pages/HabitatLandlordProfile';
import LeaseAgreement from './features/habitat/pages/LeaseAgreement';
import VaultViewer from './features/habitat/pages/VaultViewer';
import LeaseSuccess from './features/habitat/pages/LeaseSuccess';

// ✅ NOUVELLE VERTICALE : FORFEO PROS
import ProDashboard from './features/forfeopros/pages/ProDashboard';

// --- COMPOSANTS ---
import CreatePassport from './components/CreatePassport';
import Flights from './components/Flights';
import InteractiveMap from './components/InteractiveMap';
import SmartAssistantWidget from './components/SmartAssistantWidget';
import ErrorBoundary from './components/ErrorBoundary';
import { AppRouteHealthGuard } from './components/system/AppRouteHealthGuard';
import AffiliateTracker from './components/AffiliateTracker';
import InstallPWA from './components/InstallPWA';
import PageShell from './components/layout/PageShell';
import AutoTranslate from './components/i18n/AutoTranslate';
import MarketingTracker from './components/analytics/MarketingTracker';
import ForfeoExploreHandoffLayer from './components/handoff/ForfeoExploreHandoffLayer';

// --- PANIER ---
import { CartProvider } from './context/CartContext';
import CartSidebar from './components/CartSidebar';

// --- RADIO ---
import { MOODS } from './components/DJWidget';

import ForfeoProtectedRoute from './components/auth/ForfeoProtectedRoute';
import ForfeoReserve from './pages/ForfeoReserve';
import ReserveSiteLauncher from './components/reserve/ReserveSiteLauncher';
import './styles/commerce-v218-final-targeted-visual.css';
import './styles/commerce-v219-interactive-state-lock.css';
import './styles/commerce-v220-readable-state-lock.css';
import './styles/commerce-v221-dining-chip-label-lock.css';
/**
 * AppRouteShell
 *
 * Couche globale non destructive :
 * - ajoute le bouton retour accueil sur chaque page sauf l'accueil ;
 * - ajoute le bouton retour à la page précédente via PageShell / SmartPageNavigation ;
 * - garde le bouton FR/EN uniquement dans le Header pour éviter les doublons ;
 * - garde les layouts existants grâce à fullWidth ;
 * - évite de modifier chaque page une par une ;
 * - conserve toutes les routes et tous les composants actuels.
 */
function AppRouteShell({
  children,
  showBackHome = true,
}: {
  children: React.ReactNode;
  showBackHome?: boolean;
}) {
  return (
    <PageShell
      fullWidth
      showBackHome={showBackHome}
      showLanguageSwitcher={false}
      backHomeVariant="floating"
      className="bg-transparent"
      contentClassName="w-full"
    >
      {children}
    </PageShell>
  );
}

/**
 * ScrollToTop
 */
function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname, search]);

  return null;
}


function ClubRouteSmart() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tab = params.get('tab');

  if (tab === 'trips' || tab === 'billets' || tab === 'purchases' || tab === 'achats') {
    return <Navigate to="/mes-achats" replace />;
  }

  if (tab === 'favorites' || tab === 'favoris') {
    return <Navigate to="/mes-favoris" replace />;
  }

  if (tab === 'reservations' || tab === 'réservations') {
    return <Navigate to="/mes-reservations" replace />;
  }

  if (tab === 'alerts' || tab === 'alertes') {
    return <Navigate to="/mes-alertes" replace />;
  }

  return <ClubForfeo />;
}

/**
 * Loading Screen
 */
function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-blue-900 flex flex-col items-center justify-center p-4">
      <div className="text-center">
        <div className="relative">
          <div className="w-24 h-24 mx-auto mb-6">
            <div className="w-full h-full rounded-2xl bg-gradient-to-r from-blue-500 to-cyan-400 flex items-center justify-center">
              <div className="text-white text-3xl font-black">F</div>
            </div>
            <div className="absolute inset-0 rounded-2xl border-4 border-blue-400 animate-ping opacity-30" />
          </div>

          <div className="space-y-4">
            <h1 className="text-2xl md:text-3xl font-black text-white mb-2">
              Forfeo{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">
                Explore
              </span>
            </h1>
            <p className="text-blue-200 text-sm">
              Chargement de votre expérience voyage...
            </p>

            <div className="flex justify-center gap-1">
              <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" />
              <div
                className="w-2 h-2 bg-blue-400 rounded-full animate-bounce"
                style={{ animationDelay: '0.2s' }}
              />
              <div
                className="w-2 h-2 bg-blue-400 rounded-full animate-bounce"
                style={{ animationDelay: '0.4s' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Maintenance Banner
 */
function MaintenanceBanner() {
  return (
    <div className="bg-white rounded-3xl p-8 max-w-md w-full text-center shadow-2xl border border-slate-200">
      <h2 className="text-2xl font-black text-slate-900 mb-2">
        Maintenance en cours
      </h2>
      <p className="text-slate-600 mb-4">
        Forfeo Explore est actuellement en maintenance pour améliorer votre expérience.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-bold transition w-full"
      >
        Actualiser la page
      </button>
    </div>
  );
}

function App() {
  const [radioState, setRadioState] = useState({
    mood: 'roadtrip',
    isPlaying: false,
    volume: 70,
  });

  const [isLoading, setIsLoading] = useState(true);
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [isOnline, setIsOnline] = useState(true);

  // STATUS
  useEffect(() => {
    const maintenance = import.meta.env.VITE_MAINTENANCE_MODE === 'true';
    setMaintenanceMode(maintenance);

    setIsOnline(navigator.onLine);

    const t = window.setTimeout(() => setIsLoading(false), 1000);

    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.clearTimeout(t);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // RADIO EVENTS
  useEffect(() => {
    const handleRadioChange = (e: any) => {
      setRadioState((prev) => {
        const newState = { ...prev, ...e.detail };
        window.dispatchEvent(new CustomEvent('radioUpdate', { detail: newState }));
        return newState;
      });
    };

    window.addEventListener('changeRadio', handleRadioChange);
    return () => window.removeEventListener('changeRadio', handleRadioChange);
  }, []);

  if (isLoading) return <LoadingScreen />;

  if (maintenanceMode) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 to-blue-900 flex items-center justify-center p-4">
        <MaintenanceBanner />
      </div>
    );
  }

  return (
    <CartProvider>
      <AffiliateTracker />
      <MarketingTracker />
      <ScrollToTop />
      <AutoTranslate />

      <AnimatePresence>
        {!isOnline && (
          <motion.div
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -50, opacity: 0 }}
            className="fixed top-0 left-0 right-0 z-[9999] bg-yellow-500 text-white text-center py-2 px-4"
          >
            <p className="text-sm font-medium">
              ⚠️ Vous êtes hors ligne. Certaines fonctionnalités sont limitées.
            </p>
          </motion.div>
        )}
      </AnimatePresence>

      <CartSidebar />

      <ErrorBoundary>
        <AppRouteHealthGuard>
        <>
      <ForfeoRouteExperience />
      <ForfeoRouteBoundary>
        <Routes>
          <Route path="/" element={<AppRouteShell><Home /></AppRouteShell>} />
          <Route path="/about" element={<AppRouteShell><About /></AppRouteShell>} />

          {/* ✅ PAGES CONFIANCE / SEO / INFOS */}
          <Route path="/comment-ca-marche" element={<AppRouteShell><CommentCaMarche /></AppRouteShell>} />
          <Route path="/confiance" element={<AppRouteShell><Confiance /></AppRouteShell>} />
          <Route path="/securite" element={<Navigate to="/confiance" replace />} />
          <Route path="/sécurité" element={<Navigate to="/confiance" replace />} />
          <Route path="/aide" element={<AppRouteShell><Aide /></AppRouteShell>} />
          <Route path="/partenaires" element={<AppRouteShell><Partenaires /></AppRouteShell>} />
          <Route path="/carte-cadeau" element={<AppRouteShell><CarteCadeauUniverselle /></AppRouteShell>} />
          {/* ✅ PAGE PUBLIQUE OFFRIR UN MOMENT */}
          <Route path="/offrir-un-moment" element={<AppRouteShell><GiftMoment /></AppRouteShell>} />
          <Route path="/gift-a-moment" element={<AppRouteShell><GiftMoment /></AppRouteShell>} />
          <Route path="/offrir" element={<Navigate to="/offrir-un-moment" replace />} />
          <Route path="/calendrier-des-occasions" element={<AppRouteShell><OccasionCalendar /></AppRouteShell>} />
          <Route path="/occasion-calendar" element={<AppRouteShell><OccasionCalendar /></AppRouteShell>} />
          <Route path="/calendrier" element={<Navigate to="/calendrier-des-occasions" replace />} />
          <Route path="/occasions" element={<Navigate to="/calendrier-des-occasions" replace />} />
          <Route path="/revelation-surprise" element={<AppRouteShell><SurpriseReveal /></AppRouteShell>} />
          <Route path="/surprise-reveal" element={<AppRouteShell><SurpriseReveal /></AppRouteShell>} />
          <Route path="/reveler-mon-cadeau" element={<AppRouteShell><SurpriseReveal /></AppRouteShell>} />
          <Route path="/reveal" element={<Navigate to="/revelation-surprise" replace />} />
          <Route path="/avis-experience" element={<AppRouteShell><ReviewAfterExperience /></AppRouteShell>} />
          <Route path="/avis-apres-experience" element={<Navigate to="/avis-experience" replace />} />
          <Route path="/experience-review" element={<AppRouteShell><ReviewAfterExperience /></AppRouteShell>} />
          <Route path="/review" element={<Navigate to="/avis-experience" replace />} />

          <Route path="/combos" element={<AppRouteShell><PublicCombos /></AppRouteShell>} />
          <Route path="/combos-forfeo" element={<AppRouteShell><PublicCombos /></AppRouteShell>} />
          <Route path="/combos/:slug" element={<AppRouteShell><PublicComboDetail /></AppRouteShell>} />
          <Route path="/combos-marchands" element={<AppRouteShell><MerchantCombos /></AppRouteShell>} />
          <Route path="/merchant/combos" element={<AppRouteShell><MerchantCombos /></AppRouteShell>} />
          <Route path="/services-qualite" element={<AppRouteShell><QualityServices /></AppRouteShell>} />
          <Route path="/clients-mysteres" element={<AppRouteShell><QualityServices /></AppRouteShell>} />
          <Route path="/sondages-clients" element={<AppRouteShell><QualityServices /></AppRouteShell>} />
          <Route path="/combos-partenaires" element={<AppRouteShell><PartnerCombosBrochure /></AppRouteShell>} />
          <Route path="/feuillet-combos" element={<AppRouteShell><PartnerCombosBrochure /></AppRouteShell>} />
          <Route path="/partenaires/combos" element={<AppRouteShell><PartnerCombosBrochure /></AppRouteShell>} />
          <Route path="/univers-forfeo" element={<AppRouteShell><ForfeoUniverseBridge /></AppRouteShell>} />
          <Route path="/avis-publics" element={<AppRouteShell><PublicReviews /></AppRouteShell>} />
          <Route path="/avis-clients" element={<AppRouteShell><PublicReviews /></AppRouteShell>} />
          <Route path="/avis" element={<AppRouteShell><PublicReviews /></AppRouteShell>} />
          <Route path="/forfaits-collaboratifs" element={<Navigate to="/combos" replace />} />
          <Route path="/bundles" element={<Navigate to="/combos" replace />} />
          <Route path="/carte-cadeau-universelle" element={<Navigate to="/carte-cadeau" replace />} />
          <Route path="/gift-card" element={<Navigate to="/carte-cadeau" replace />} />
          <Route path="/universal-gift-card" element={<Navigate to="/carte-cadeau" replace />} />

          {/* ✅ ROUTES HABITAT */}
          <Route path="/habitat" element={<AppRouteShell><HabitatLanding /></AppRouteShell>} />
          <Route path="/habitat/proprio/dashboard" element={<ForfeoProtectedRoute requiredPermission="habitat:landlord"><AppRouteShell><LandlordDashboard /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/habitat/proprio/:id" element={<AppRouteShell><HabitatLandlordProfile /></AppRouteShell>} />
          <Route path="/habitat/locataire/dashboard" element={<ForfeoProtectedRoute requiredPermission="habitat:tenant"><AppRouteShell><TenantDashboard /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/habitat/logement/:id" element={<AppRouteShell><HabitatListing /></AppRouteShell>} />
          <Route path="/habitat/lease/:appId" element={<AppRouteShell><LeaseAgreement /></AppRouteShell>} />
          <Route path="/habitat/vault-viewer/:tenantId" element={<AppRouteShell><VaultViewer /></AppRouteShell>} />
          <Route path="/habitat/success/:appId" element={<AppRouteShell><LeaseSuccess /></AppRouteShell>} />

          {/* ✅ NOUVELLE ROUTE FORFEO PROS */}
          <Route path="/forfeopro/dashboard" element={<ForfeoProtectedRoute requiredPermission="forfeopro:access"><AppRouteShell><ProDashboard /></AppRouteShell></ForfeoProtectedRoute>} />

          {/* ✅ NOUVELLE ROUTE : DÉMO DYNAMIQUE SDR */}
          <Route path="/demo/:companySlug" element={<AppRouteShell><DynamicDemo /></AppRouteShell>} />

          <Route path="/service-client" element={<AppRouteShell><ServiceClient /></AppRouteShell>} />

          <Route path="/region/:id" element={<AppRouteShell><RegionDetail /></AppRouteShell>} />
          <Route path="/carte" element={<AppRouteShell><InteractiveMap /></AppRouteShell>} />
          <Route path="/vols" element={<AppRouteShell><Flights /></AppRouteShell>} />
          <Route path="/comparateur-voyage" element={<AppRouteShell><TravelComparator /></AppRouteShell>} />
          <Route path="/comparateur" element={<Navigate to="/comparateur-voyage" replace />} />

          <Route path="/place/:id" element={<AppRouteShell><BusinessProfile /></AppRouteShell>} />
          <Route path="/explore/hotel/:id" element={<AppRouteShell><BusinessProfile /></AppRouteShell>} />

          <Route path="/register-business" element={<AppRouteShell><MerchantOnboarding /></AppRouteShell>} />
          <Route path="/business" element={<AppRouteShell><Business /></AppRouteShell>} />
          <Route path="/reseau-local" element={<AppRouteShell><LocalNetwork /></AppRouteShell>} />
          <Route path="/login" element={<AppRouteShell><Login /></AppRouteShell>} />

          {/* ✅ ROUTE PUBLIQUE FORFEO SIGN */}
          <Route path="/sign/:contractId" element={<SignContract />} />

          <Route path="/visiter-quebec" element={<AppRouteShell><VisitQuebec /></AppRouteShell>} />

          {/* ✅ PAGE PUBLIQUE DÉCOUVRIR LE QUÉBEC */}
          <Route path="/decouvrir-quebec" element={<AppRouteShell><DiscoverQuebec /></AppRouteShell>} />
          <Route path="/découvrir-quebec" element={<Navigate to="/decouvrir-quebec" replace />} />
          <Route path="/discover-quebec" element={<AppRouteShell><DiscoverQuebec /></AppRouteShell>} />
          <Route path="/discover-quebec-city" element={<Navigate to="/discover-quebec" replace />} />

          <Route path="/club" element={<AppRouteShell><ClubRouteSmart /></AppRouteShell>} />
          <Route path="/club/billets" element={<Navigate to="/mes-achats" replace />} />
          <Route path="/club/achats" element={<Navigate to="/mes-achats" replace />} />
          <Route path="/club/favoris" element={<Navigate to="/mes-favoris" replace />} />
          <Route path="/club/reservations" element={<Navigate to="/mes-reservations" replace />} />
          <Route path="/club/alertes" element={<Navigate to="/mes-alertes" replace />} />
          <Route path="/mes-favoris" element={<ForfeoProtectedRoute requiredPermission="consumer:access"><AppRouteShell><MyFavorites /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/dashboard-voyageur/messages" element={<ForfeoProtectedRoute requiredPermission="consumer:access"><AppRouteShell><ClubForfeo /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/create-passport" element={<AppRouteShell><CreatePassport /></AppRouteShell>} />

          <Route path="/boutique" element={<AppRouteShell><Boutique /></AppRouteShell>} />
          <Route path="/boutique/:id" element={<AppRouteShell><BoutiqueDetail /></AppRouteShell>} />

          <Route path="/last-call" element={<AppRouteShell><LastCall /></AppRouteShell>} />
          <Route path="/forfeo-finds" element={<AppRouteShell><ForfeoFinds /></AppRouteShell>} />
          <Route path="/checkout" element={<AppRouteShell><Checkout /></AppRouteShell>} />

          <Route path="/prevente" element={<AppRouteShell><ForfaitPresale /></AppRouteShell>} />
          <Route path="/generateur-ia" element={<AppRouteShell><AiTripBuilder /></AppRouteShell>} />
          <Route path="/drops" element={<AppRouteShell><ForfeoDrops /></AppRouteShell>} />

          {/* ✅ ROUTES ÉVASION / ALERTES INTELLIGENTES */}
          <Route path="/evasion" element={<AppRouteShell><Evasion /></AppRouteShell>} />
          <Route path="/alertes-intelligentes" element={<AppRouteShell><SmartAlerts /></AppRouteShell>} />
          <Route path="/smart-travel-alerts" element={<AppRouteShell><SmartAlerts /></AppRouteShell>} />
          <Route path="/smart-alerts" element={<Navigate to="/alertes-intelligentes" replace />} />
          <Route path="/mes-alertes" element={<ForfeoProtectedRoute requiredPermission="consumer:access"><AppRouteShell><EvasionDashboard /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/mes-alertes-intelligentes" element={<ForfeoProtectedRoute requiredPermission="consumer:access"><AppRouteShell><SmartAlertsDashboard /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/my-smart-alerts" element={<Navigate to="/mes-alertes-intelligentes" replace />} />

          {/* ✅ ESPACE VOYAGEUR PREMIUM */}
          <Route path="/mon-compte" element={<ForfeoProtectedRoute requiredPermission="consumer:access"><AppRouteShell><TravelerDashboard /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/gestion-compte" element={<AppRouteShell><AccountLifecycle /></AppRouteShell>} />
          <Route path="/dashboard-voyageur" element={<ForfeoProtectedRoute requiredPermission="consumer:access"><AppRouteShell><TravelerDashboard /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/mes-reservations" element={<ForfeoProtectedRoute requiredPermission="consumer:access"><AppRouteShell><MyReservations /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/mes-reservations/:id" element={<ForfeoProtectedRoute requiredPermission="consumer:access"><AppRouteShell><ReservationDetail /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/reservation/:id" element={<ForfeoProtectedRoute requiredPermission="consumer:access"><AppRouteShell><ReservationDetail /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/mes-achats" element={<ForfeoProtectedRoute requiredPermission="consumer:access"><AppRouteShell><MyPurchases /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/voucher/:token" element={<AppRouteShell><VoucherDetail /></AppRouteShell>} />

          <Route path="/reserve/widget/:publicKey" element={<ReservePartnerWidgetPage />} />

          <Route path="/business-dashboard" element={<ForfeoProtectedRoute requiredPermission="merchant:manage"><AppRouteShell showBackHome={false}><BusinessDashboard /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/affiliate-dashboard" element={<ForfeoProtectedRoute requiredPermission="affiliate:access"><AppRouteShell><AffiliateDashboard /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/prp-dashboard" element={<ForfeoProtectedRoute requiredPermission="prp:access"><AppRouteShell showBackHome={false}><><PRPDashboard /><PrpGrowthCockpit /></></AppRouteShell></ForfeoProtectedRoute>} />

          <Route path="/admin" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><Admin /></AppRouteShell></ForfeoProtectedRoute>} />
            <Route path="/admin/operations" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminOperations /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin/integrations-partenaires" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminReserveIntegrations /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin-forfeo-portal" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><Admin /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin/gouvernance-contenus" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminContentGovernance /></AppRouteShell></ForfeoProtectedRoute>} />
                  <Route path="/aide/formation" element={<AppRouteShell><IntegratedHelpCenter /></AppRouteShell>} />
          <Route path="/admin/qualite" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminQualityServices /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin/securite" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminSecurityCenter /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin/materiel-partenaires" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminPartnerMaterials /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin/combos" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminCombos /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin/commissions" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminCommissionSettings /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin/emails" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminEmailSequences /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin/avis" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminExperienceReviews /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin/last-call" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminLastCallReservations /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin/leads" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminLeads /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin/analytics" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminMarketingAnalytics /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin/explorer-plus" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminExplorerPlusAnalytics /></AppRouteShell></ForfeoProtectedRoute>} />
          <Route path="/admin/commandes-vouchers" element={<ForfeoProtectedRoute requiredPermission="platform:admin"><AppRouteShell><AdminOrdersVouchers /></AppRouteShell></ForfeoProtectedRoute>} />

          <Route path="/privacy" element={<AppRouteShell><Privacy /></AppRouteShell>} />
          <Route path="/terms" element={<AppRouteShell><Terms /></AppRouteShell>} />
          <Route path="/terms-loyalty" element={<AppRouteShell><TermsLoyalty /></AppRouteShell>} />

          <Route path="/explorer-plus" element={<AppRouteShell><ExplorePlus /></AppRouteShell>} />
          <Route path="/explore/:category/:id" element={<AppRouteShell><ExplorePlus /></AppRouteShell>} />

          <Route path="/booking/success" element={<AppRouteShell><BookingSuccess /></AppRouteShell>} />
          <Route path="/booking/:businessId" element={<AppRouteShell><BookingPage /></AppRouteShell>} />

          <Route path="/quebec/:city/:slug" element={<AppRouteShell><SeoCityLanding /></AppRouteShell>} />
          <Route path="/quebec/last-call" element={<AppRouteShell><SeoCityLanding /></AppRouteShell>} />

          <Route path="/agent" element={<AppRouteShell><AgentConsole /></AppRouteShell>} />

          <Route path="/newsletter/unsubscribe" element={<AppRouteShell><NewsletterUnsubscribe /></AppRouteShell>} />
          <Route path="/unsubscribe" element={<AppRouteShell><NewsletterUnsubscribe /></AppRouteShell>} />

          <Route path="/regions" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
                <Route path="/reserve" element={<AppRouteShell><ForfeoReserve /></AppRouteShell>} />
</Routes>
      <ReserveSiteLauncher />
      </ForfeoRouteBoundary>
    </>
        </AppRouteHealthGuard>
      </ErrorBoundary>

      <div style={{ position: 'fixed', width: 0, height: 0, overflow: 'hidden' }}>
        {radioState.isPlaying && (
          <iframe
            id="forfy-radio-engine"
            src={`https://www.youtube.com/embed/${(MOODS as any)[radioState.mood].videoId}?autoplay=1&mute=0&controls=0&enablejsapi=1`}
            allow="autoplay; encrypted-media"
            title="Forfy Radio Engine"
          />
        )}
      </div>

      <SmartAssistantWidget />
      <ForfeoExploreHandoffLayer />

      <InstallPWA />

      <footer data-forfeo-fixed-footer className="fixed bottom-0 left-0 right-0 z-[9996] bg-white/80 backdrop-blur-lg border-t border-slate-200 py-2 px-4">
        <div className="flex items-center justify-between text-xs text-slate-600">
          <span>© 2026 Forfeo Explore Québec</span>
          <div className="flex gap-4">
            <button onClick={() => window.open('/privacy', '_blank')}>
              Confidentialité
            </button>
            <button onClick={() => window.open('/terms', '_blank')}>
              Conditions
            </button>
          </div>
        </div>
      </footer>

      <div id="modal-overlay" className="fixed inset-0 z-[9995] pointer-events-none" />
    </CartProvider>
  );
}

export default App;
